import useGlobalStore from '@/store/useGlobalStore'
import { removeAuthCookie } from '@/lib/utils/shared/cookies/removeAuthCookie'
import { mixpanelService } from '@/lib/services/mixpanel/initializeMixPanel'
import { MixpanelEvent } from '@/lib/services/mixpanel/mixpanelEvent'
import useClientRedirect from '../routing/useRedirect'
import { useGTM } from '../google-analytics/useGTM'

export const useSignOutUser = () => {
  const { resetStoreWithoutTranslations, setLoaders } = useGlobalStore()
  const { clientRedirect } = useClientRedirect()
  const { gtm } = useGTM()

  const signOutUser = async () => {
    await clientRedirect.to({ path: '/' })

    resetStoreWithoutTranslations()
    removeAuthCookie({})
    setLoaders({ isLoadingSigningOut: true })

    gtm.logout()

    mixpanelService.trackEvent(MixpanelEvent.LOGOUT, {}).catch(() => {})

    mixpanelService.reset()

    // Force a reload to make sure everything is cleaned up
    // Timeout required for gtm event to fire correctly
    if (window) {
      setTimeout(() => {
        setLoaders({ isLoadingSigningOut: false })
        window.location.reload()
      }, 100)
    }
  }

  return { signOutUser }
}
